<template>
  <div class="minW1060-auto bg-fff mag10 pad10">
    <el-row class="text-left">

      <div class="dlblock-mb20 mr10">
        <span class="pr5">用户名</span>
        <el-input v-model.trim="userName" placeholder="请输入" style="width: 150px;"/>
      </div>

      <div class="dlblock-mb20 mr10">
        <span class="pr5">状态</span>
        <el-select v-model="userStsName" class="w150" clearable>
          <el-option label="正常" value="正常"/>
          <el-option label="冻结" value="冻结"/>
        </el-select>
      </div>

      <div class="dlblock-mb20 mr10">
	    <span class="pr5">创建时间</span>
	    <el-date-picker
	        v-model="createTime"
	        style="width: 180px;"
	        type="datetime"
			    class="reset-clear"
			    :clearable="false"
			    unlink-panels
	        value-format="yyyy-MM-dd HH:mm:ss"
	        start-placeholder="开始日期"
	        />
	     </div> 
	  

	  	<div class="dlblock-mb20 mr10">
	    <span class="pr5">结束日期</span>
	    <el-date-picker
          v-model="updateTime"
		  style="width: 180px;"
          type="datetime"
          :clearable="false"
          unlink-panels
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
           />
	  </div> 

      <div class="dlblock-mb20 mr10">
        <el-button type="primary" @click="pages.page = 1; getUserPageFn()">
          搜索
        </el-button>
      </div>

     <!-- <div class="dlblock-mb20 mr10">
        <el-button type="primary" @click="editBtn(1)">
          邀请好友设置
        </el-button>
      </div> -->

    <!--  <div class="dlblock-mb20">
        <el-button type="primary" @click="editBtn(2)">
          新用户奖励
        </el-button>
      </div> -->

    </el-row>

    <el-table class="my-table" :data="tableData" v-loading="tableLoading" :header-row-class-name="'my-table-header'">
      <el-table-column align="center" prop="depName" label="所属部门"></el-table-column>
      <el-table-column align="center" prop="loginCode" label="学工号"></el-table-column>
      <el-table-column align="center" prop="userName" label="姓名"></el-table-column>
      <el-table-column align="center" prop="userStsName" label="用户状态"></el-table-column>
      <el-table-column align="center" prop="crgBal" label="充值余额"></el-table-column>
      <el-table-column align="center" prop="alloBal" label="补助余额"></el-table-column>
      <el-table-column align="center" prop="bal" label="余额合计"></el-table-column>

   <!--   <el-table-column align="center" width="200" label="操作">
        <template slot-scope="{row}">
          <a class="glob-a" @click="statusBtn(3, row)">查看</a>
          <a class="glob-a" @click="statusBtn(1, row)">{{row.openFlagValue === 'NONPROHIBITED' ? '禁用': '启用'}}</a>
          <a class="glob-a" @click="statusBtn(2, row)">广告权限</a>
        </template>
      </el-table-column> -->

    </el-table>

    <div class="my-pagination">
      <el-pagination background layout="total, prev, pager, next" :total="pages.total"
                     :current-page="pages.page" @current-change="pageChange">
      </el-pagination>
    </div>

    <!-- 账号状态设置 -->
    <el-dialog title="账号状态设置" :visible.sync="statusData.modal" width="550px">
      <el-form :model="statusData" label-width="120px">
        <el-form-item label="当前账号状态:">
          {{statusData.typeName}}
        </el-form-item>
        <el-form-item :label="statusData.type === 'PROHIBIT' ? '启用时间' : '禁用时间:'">
          <el-date-picker
              v-model="statusData.date"
              style="width: 300px;"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
          />
        </el-form-item>
        <el-form-item label="禁用说明:" v-if="statusData.type === 'NONPROHIBITED'">
          <el-input
              type="textarea"
              :rows="5"
              style="width: 300px;"
              maxlength="100"
              resize="none"
              v-model="statusData.content"
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="statusData.modal = false">取 消</el-button>
        <el-button type="primary" @click="statusSave">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 广告权限设置 -->
    <el-dialog title="广告权限设置" :visible.sync="adData.modal" width="500px">
      <el-row>
        <el-col :span="12" class="pl20">
          <el-checkbox :indeterminate="adData.adTypeIsIndeterminate"
                       v-model="adData.adTypeAll"
                       class="mb20"
                       @change="adTypeAllChange($event, 1)">
            全选 (禁止发布任何广告)
          </el-checkbox>
          <el-checkbox-group v-model="adData.adType" @change="adTypeChange($event, 1)">
            <el-checkbox class="dblock mb20" v-for="(item,index) in adTypeList" :label="item.value" :key="index">
              {{item.name}}
            </el-checkbox>
          </el-checkbox-group>
        </el-col>
        <el-col :span="12">
          <el-checkbox :indeterminate="adData.adPositionIsIndeterminate"
                       v-model="adData.adPositionAll"
                       class="mb20"
                       @change="adTypeAllChange($event, 2)">
            全选 (禁止投放任何广告)
          </el-checkbox>
          <el-checkbox-group v-model="adData.adPosition" @change="adTypeChange($event, 2)">
            <el-checkbox class="dblock mb20" v-for="(item,index) in adPositionList" :label="item.value" :key="index">
              {{item.name}}
            </el-checkbox>
          </el-checkbox-group>
        </el-col>
      </el-row>

      <div slot="footer">
        <el-button @click="adData.modal = false">取 消</el-button>
        <el-button type="primary" @click="adSave">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 详情 -->
    <el-dialog title="查看" :visible.sync="detailModal" fullscreen>
      <detail :id="detailId"/>
    </el-dialog>

    <!-- 邀请好友设置 -->
    <el-dialog title="邀请好友设置" :visible.sync="friendData.modal" width="500px">
      <el-form label-width="120px">
        <el-form-item label="邀请人分成比例">
          <el-input v-model.trim="friendData.ratio" type="number" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="邀请规则">
          <el-input v-model.trim="friendData.content" type="textarea" :rows="5" resize="none" placeholder="请输入"/>
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button @click="friendData.modal = false">取 消</el-button>
        <el-button type="primary" @click="editSave(1)">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 新用户奖励 -->
    <el-dialog title="新用户奖励" :visible.sync="newUserData.modal" width="400px">
      <el-form label-width="150px">
        <el-form-item label="奖励购物金金额">
          <el-input v-model.trim="newUserData.value" type="number" placeholder="请输入"/>
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button @click="newUserData.modal = false">取 消</el-button>
        <el-button type="primary" @click="editSave(2)">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    getUserbalanceRecord,

    getUserPage,
    getAgentTree,
    getAreaTreeOnlyCityProvince,
    setUserStatus,
    getUserFriend,
    setUserFriend,
    getUserNewUserRule,
    setUserNewUserRule,
    getUserAdAuth,
    setUserAdAuth
  } from '@/api'

  export default {
    name: 'UserList',
    data () {
      return {
        userName:'',
        createTime:'',
        updateTime:'',
        userStsName:'',

        date: [],
        status: '',
        city: [],
        cityList: [],
        agent: '',
        agentList: [],
        name: '',
        phone: '',
        tableData: [],
        tableLoading: false,
        pages: {
          page: 1,
          total: 0
        },
        // 详情
        detailId: '',
        detailModal: false,
        // 状态
        statusData: {
          modal: false,
          userId: '',
          type: '',
          typeName: '',
          date: [],
          content: ''
        },
        // 广告权限
        adData: {
          modal: false,
          userId: '',
          adTypeAll: false,
          adType: [],
          adTypeIsIndeterminate: false,
          adPositionAll: false,
          adPosition: [],
          adPositionIsIndeterminate: false,
        },
        adTypeList: [
          {name: '禁止发布通用广告', value: 'NORMAL'},
          {name: '禁止发布商品广告', value: 'GOODS'},
          {name: '禁止发布视频广告', value: 'VIDEO'},
          {name: '禁止发布外链广告', value: 'OUT_LINK'},
        ],
        adPositionList: [
          {name: '禁止投放列表', value: 'LIST'},
          {name: '禁止投放内容', value: 'CONTENT'},
          // {name: '禁止投放详情', value: 'DETAIL'},
        ],
        // 邀请好友设置
        friendData: {
          modal: false,
          ratio: '',
          content: ''
        },
        // 新用户奖励
        newUserData: {
          modal: false,
          value: ''
        }
      }
    },
    created () {
      this.getUserPageFn()
      //this.getAgentTreeFn()
      //this.getAreaTreeOnlyCityProvinceFn()
    },
    methods: {
      adSave () {
        this.adData.modal = false
        setUserAdAuth({
          userId: this.adData.userId,
          adType: this.adData.adType,
          adPosition: this.adData.adPosition
        }).then(res => {
          this.$message.success(res.data)
          this.adData.modal = false
          this.getUserPageFn()
        })
      },
      adTypeAllChange (val, t) {
        if (t === 1) {
          this.adData.adType = val ? this.adTypeList.map(item => item.value) : []
          this.adData.adTypeIsIndeterminate = false
        } else {
          this.adData.adPosition = val ? this.adPositionList.map(item => item.value) : []
          this.adData.adPositionIsIndeterminate = false
        }
      },
      adTypeChange (value, t) {
        if (t == 1) {
          let checkedCount = value.length
          this.adData.adTypeAll = checkedCount === this.adTypeList.length
          this.adData.adTypeIsIndeterminate = checkedCount > 0 && checkedCount < this.adTypeList.length
        } else {
          let checkedCount = value.length
          this.adData.adPositionAll = checkedCount === this.adPositionList.length
          this.adData.adPositionIsIndeterminate = checkedCount > 0 && checkedCount < this.adPositionList.length
        }
      },
      editSave (t) {
        switch (t) {
          case 1:
            setUserFriend({
              proportion: this.friendData.ratio,
              ruleDescription: this.friendData.content,
            }).then(res => {
              this.$message.success(res.data)
              this.friendData.modal = false
            })
            break
          case 2:
            setUserNewUserRule(this.newUserData.value).then(res => {
              this.$message.success(res.data)
              this.newUserData.modal = false
            })
            break
        }
      },
      // t: 1邀请好友设置 2新用户奖励
      editBtn (t) {
        switch (t) {
          case 1:
            getUserFriend().then(res => {
              this.friendData = {
                modal: true,
                ratio: res.data.propertyValue,
                content: res.data.propertyDesc
              }
            })
            break
          case 2:
            getUserNewUserRule().then(res => {
              this.newUserData = {
                modal: true,
                value: res.data
              }
            })
            break
        }
      },
      statusSave () {
        setUserStatus({
          userId: this.statusData.userId,
          openFlag: this.statusData.type === 'NONPROHIBITED' ? 'PROHIBIT' : 'NONPROHIBITED',
          frozenStartTime: this.statusData.date && this.statusData.date.length ? this.statusData.date[0] : '',
          frozenExpiryTime: this.statusData.date && this.statusData.date.length > 1 ? this.statusData.date[1] : '',
          frozenReason: this.statusData.content,
        }).then(res => {
          this.$message.success(res.data)
          this.statusData.modal = false
          this.getUserPageFn()
        })
      },
      // t: 1切换状态 2广告权限 3查看
      statusBtn (t, row) {
        if (t == 1) {
          this.statusData = {
            modal: true,
            userId: row.userId,
            type: row.openFlagValue,
            typeName: row.openFlag,
            date: [],
            content: ''
          }
        } else if (t == 2) {
          getUserAdAuth(row.userId).then(res => {
            this.adData.modal = true
            this.adData.userId = row.userId
            this.adData.adType = res.data.adType
            this.adData.adPosition = res.data.adPosition

            this.adTypeChange(res.data.adType, 1)
            this.adTypeChange(res.data.adPosition, 2)
          })
        } else {
          this.detailModal = true
          this.detailId = row.userId
        }
      },
      getUserPageFn () {
        this.tableLoading = true
        getUserbalanceRecord({
          pageNum: this.pages.page,
          userName: this.userName,
          createTime: this.createTime,
          updateTime: this.updateTime,
          userStsName:this.userStsName
        }).then(res => {
          this.tableData = res.data.records
          this.pages.total = res.data.total
        }).finally(() => {
          this.tableLoading = false
        })
      },
      pageChange (val) {
        this.pages.page = val
        this.getUserPageFn()
      },
      getAgentTreeFn () {
        getAgentTree().then(res => {
          this.agentList = res.data
        })
      },
      getAreaTreeOnlyCityProvinceFn () {
        getAreaTreeOnlyCityProvince().then(res => {
          this.cityList = res.data
        })
      }
    }
  }
</script>

<style scoped>

</style>
